<template>
    <div id="slider_box" style="width: 100vw; height: 100vh;"></div>
</template>


<script>
// import people from '@/assets/people';
// import Three from "three";
// import OrbitControls from 'three-orbitcontrols';
// import {CSS2DRenderer, CSS2DObject} from 'three-css2drender';
// import SpriteText from 'three-spritetext';
// import { MeshText2D, textAlign } from 'three-text2d';


export default {
  name: "ComponentSlider",
  data() {
    return {};
  },
  created() {
    this.ready()
  },
  methods: {
    ready(){

      jQuery(document).ready(function() {
          var renderer, scene, camera, x, y, z, n, controls, parent, labelRenderer;

          renderer = new THREE.WebGLRenderer({ antialias: true });
          renderer.setClearColor(0xdbdbdb);
          renderer.setSize(window.innerWidth, window.innerHeight);

          labelRenderer = new THREE.CSS2DRenderer();
          labelRenderer.setSize(window.innerWidth, window.innerHeight);
          labelRenderer.domElement.style.position = 'absolute';
          labelRenderer.domElement.style.top = 0;
          labelRenderer.domElement.style.right = 0;
          document.getElementById("slider_box").appendChild( labelRenderer.domElement );

          // SCENE
          scene = new THREE.Scene();

          // CAMERA
          camera = new THREE.PerspectiveCamera(40, window.innerWidth / window.innerHeight, 1, 10000);
          camera.position.set(0, 0, 0.1);

          // CONTROLS
          controls = new THREE.OrbitControls(camera);
          controls.minPolarAngle = Math.PI/2;
          controls.maxPolarAngle = Math.PI/2;
          controls.enableZoom = false;
          controls.rotateSpeed = 0.4;
          controls.enableDamping = true;
          controls.dampingFactor = 0.1;
          controls.rotateSpeed = 0.2;

          // LIGHTS
          var light = new THREE.AmbientLight(0xffffff, 0.5); //Color,intensity
          scene.add(light);
          var light1 = new THREE.PointLight(0xffffff, 0.9);
          light1.position.set( 10, -100, -150 );
          scene.add(light1);

          // OBJECTS
          // Geometry
          var geometry = new THREE.PlaneGeometry(40, 55, 7);

          // Parent
          parent = new THREE.Object3D();
          scene.add(parent);

          // Children
          n = people.length;

          for( var i=0; i<n; i++){
            var slide = new THREE.Object3D();

            // Slide
            slide.rotation.y = i* 2 * Math.PI / n;
            parent.add(slide);

            // Material and mesh
            var material = new THREE.MeshBasicMaterial({ map: new THREE.TextureLoader().load( people[i].image), side: THREE.DoubleSide });
            var mesh = new THREE.Mesh(geometry, material );
            mesh.position.z = 200;
            slide.add(mesh);

            // Text
            var name = new SpriteText(people[i].name, 3, "black", "Gilroy-ExtraBold");
            name.rotation.y = slide.rotation.y;
            name.center.x = 0;
            name.position.x = mesh.position.x-20;
            name.position.z = mesh.position.z-50;
            name.position.y = 300;
            // name.fontFace = "Gilroy-ExtraBold";
            slide.add(name);

            var profession = new SpriteText(people[i].profession, 3, "#9e9e9e", "Gilroy-Light", 70);
            profession.center.x = 0;
            profession.rotation.y = slide.rotation.y;
            profession.position.x = mesh.position.x-20;
            profession.position.z = mesh.position.z-50;
            profession.position.y = 200;
            // profession.fontFace = "Gilroy-Light";
            slide.add(profession);

            if(i % 2 == 0){
              slide.position.y = 10;
              name.position.y = mesh.position.y+16;
              profession.position.y = mesh.position.y+12;
            }else {
              slide.position.y = -10;
              name.position.y = mesh.position.y-12;
              profession.position.y = mesh.position.y-16;
            }

            scene.add(slide);
          };

          // Waving:
          controls.addEventListener( 'change', function(){
              geometry.vertices.forEach( v => {
                // density of waves↓              how fast↓  height↓
                v.z = Math.cos( 0.08 * v.x - Date.now() * 0.005 ) * 4;
              });
              geometry.verticesNeedUpdate = true;
          });

          document.getElementById("slider_box").appendChild( renderer.domElement );

          function render() {
            requestAnimationFrame( render );
            renderer.render( scene, camera );
          }
          render();
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/inner-components/ComponentSlider.vue